import accountingObjectAPI from '@/apis/di/accountingObjectAPI.js';
import accountingObjectInfoAPI from '@/apis/di/accountingObjectInfoAPI.js';
import popupUtil from '@/commons/popupUtil';
import moment from 'moment';

import { reactive, getCurrentInstance, ref, computed } from 'vue';

export const useInforCommons = () => {
  //#region sự kiện select combo
  const selectedProject = ({ newData }, me) => {
    if (newData) {
      me.model.project_name = newData.project_name;
    } else {
      me.model.project_name = '';
      me.model.project_code = '';
      me.model.project_id = null;
    }

    // xử lý gán vào đối tượng nợ grid hạch toán
    let dataGrid = me.$refs['refDetail'].getData();
    if (dataGrid && dataGrid.length > 0) {
      dataGrid.forEach(item => {
        if (item.state != me.$ms.constant.ModelState.Empty) {
          item.project_code = me.model.project_code;
          item.project_id = me.model.project_id;
        }
        if (item.state === me.$ms.constant.ModelState.None) {
          item.state = me.$ms.constant.ModelState.Update;
        }
      });
    }
  };
  // TK chi Chuyển khoản kho bạc
  const selectedBank = ({ newData }, me) => {
    if (newData) {
      me.model.bank_info_name = newData.bank_name;
      me.model.bank_name = newData.bank_name;
    } else {
      me.model.bank_info_name = '';
    }
  };

  // TK chi rút dự toán (khác field so với CKKB)
  const selectedBankBUPlan = ({ newData }, me) => {
    if (newData) {
      me.model.bank_name = newData.bank_name;
    } else {
      me.model.bank_name = '';
    }
  };

  // Chọn tài khoản nhận
  const selectedAccountingObjectBank = ({ newData }, me) => {
    if (newData) {
      me.model.accounting_object_bank_name = newData.bank_name;
    } else {
      me.model.accounting_object_bank_name = '';
    }
  };

  /**
   * Sự kiện chọn combo đơn vị nhận
   * @param {*} param0
   * @param {*} me
   * NXCHIEN 10.07.2022
   * Modified TVDAT 17.07/2022
   */
  const selectedAccountingObject = ({ newData }, me) => {
    if (newData) {
      me.model.accounting_object_name = newData.accounting_object_name;
      me.model.accounting_object_address = newData.address;
      me.model.is_employee = newData.is_employee;
      me.model.company_tax_code = newData.company_tax_code; // mã số thuế
      me.model.accounting_object_contact_name = newData.contact_name; // người đạ diện
      // lấy dữ liệu tài khoản để gán mặc định
      // Nếu là cán bộ thì lấy dữ liệu cán bô còn ko thì lấy data KH, NCC
      let payload = {};
      payload.columns = 'bank_account,bank_name';
      payload.sort = 'bank_account';
      payload.filter = JSON.stringify([
        {
          Field: 'accounting_object_id',
          Value: me.model.accounting_object_id,
        },
      ]);
      payload.take = 1000;
      // Xử lý lấy mặc định giá trị sau khi chọn combo đơn vị nhận
      if (newData.is_employee) {
        //Modified: lấy thêm mã số thuế
        //TVDAT 19/07/2022
        payload.columns += ',company_tax_code';
        accountingObjectAPI.getComboboxPaging(payload).then(result => {
          if (result && result.length) {
            me.model.accounting_object_bank_account = result[0].bank_account;
            me.model.accounting_object_bank_name = result[0].bank_name;
            me.comboboxDataRemote.bankAccount = result;
            me.model.company_tax_code = result[0].company_tax_code;
          } else {
            me.comboboxDataRemote.bankAccount = [];
            me.model.accounting_object_bank_account = null;
            me.model.accounting_object_bank_name = null;
          }
        });
      } else {
        accountingObjectInfoAPI.getComboboxPaging(payload).then(result => {
          if (result && result.length) {
            me.model.accounting_object_bank_account = result[0].bank_account;
            me.model.accounting_object_bank_name = result[0].bank_name;
            me.comboboxDataRemote.bankAccount = result;
          } else {
            me.comboboxDataRemote.bankAccount = [];
            me.model.accounting_object_bank_account = null;
            me.model.accounting_object_bank_name = null;
          }
        });
      }
    } else {
      me.model.accounting_object_name = '';
      me.model.accounting_object_address = '';
      me.model.accounting_object_code = '';
      me.model.accounting_object_id = null;
      me.model.accounting_object_bank_account = '';
      me.model.accounting_object_bank_name = '';
      me.comboboxDataRemote.bankAccount = [];
      me.model.company_tax_code = '';
    }

    // xử lý gán vào đối tượng nợ grid hạch toán
    let dataGrid = me.$refs['refDetail']?.getData();
    if (dataGrid && dataGrid.length > 0) {
      dataGrid.forEach(item => {
        if (item.state != me.$ms.constant.ModelState.Empty) {
          item.accounting_object_code = me.model.accounting_object_code;
          item.accounting_object_id = me.model.accounting_object_id;
          item.accounting_object_name = me.model.accounting_object_name;
        }
        if (item.state === me.$ms.constant.ModelState.None) {
          item.state = me.$ms.constant.ModelState.Update;
        }
      });
    }
  };

  /**
   * Lấy dữ liệu đơn vị
   * @param {*} id
   * @returns
   * NXCHIEN 09.03.2023
   */
  const getDataAccounting = async (me, id) => {
    let res = await accountingObjectAPI.getEdit({ id: id });
    if (res) {
      if (res.is_employee) {
        let obj = { bank_account: res.bank_account, bank_name: res.bank_name };
        Object.assign(obj, { company_tax_code: res.company_tax_code });
        me.comboboxDataRemote.bankAccount = [obj];
      } else {
        me.comboboxDataRemote.bankAccount = res.AccountingObjectInfos;
      }
    }

    return res;
  };

  //#endregion

  /**
   * Cập nhật ngày HT theo ngày CT
   * NXCHIEN 10.07.2022
   */
  function onBlurActionDatePicker(me) {
    if (me.model.ref_date) {
      me.model.posted_date = me.model.ref_date;
    }
    if (me.model.in_reforder) {
      let newInRefOrder = new Date(
        me.model.ref_date.getFullYear(),
        me.model.ref_date.getMonth(),
        me.model.ref_date.getDate(),
        me.model.in_reforder.getHours(),
        me.model.in_reforder.getMinutes(),
        me.model.in_reforder.getSeconds(),
      );
      me.model.in_reforder = newInRefOrder;
    }
  }

  /**
   * Xem số dư tài khoản
   * @param {*} me
   * NXCHIEN 15.07.2022
   */
  function viewAccount(me) {
    let accArrDistinct = me.getAllAccount('refDetail', 'refDetailParallel', 'refDetailOther');

    //Nếu lấy được TK trên grid Hạch toán thì mới thực hiện
    if (accArrDistinct && accArrDistinct.length > 0) {
      let param = {
        ListAccountNumber: accArrDistinct,
        //convert sang dạng string để truyền xuống đúng kiểu
        filter: JSON.stringify([
          {
            Field: 'posted_date',
            Value: moment(me.model.posted_date).format('YYYY-MM-DD'),
            Operator: me.$ms.constant.FilterOperator.LessThanEquals,
          },
        ]),
      };

      popupUtil.show('ViewAccount', {
        data: {
          accountArr: accArrDistinct,
          dateVal: me.model.posted_date,
          param: param,
        },
      });
    }
  }

  /**
   * Xem số lượng tồn vật tư
   * @param {*} me
   * NTLOC 12.08.2022
   */
  function viewQuantity(me) {
    let inventoryArrDistinct = me.getAllInventoryItem('refDetail');
    //Nếu lấy được mã hàng hóa trên grid Hạch toán thì mới thực hiện
    if (inventoryArrDistinct && inventoryArrDistinct.length > 0) {
      let param = {
        ListInventoryStock: inventoryArrDistinct,
        //convert sang dạng string để truyền xuống đúng kiểu
        filter: JSON.stringify([
          {
            Field: 'posted_date',
            Value: moment(me.model.posted_date).format('YYYY-MM-DD'),
            Operator: me.$ms.constant.FilterOperator.LessThanEquals,
          },
        ]),
      };

      popupUtil.show('ViewQuantity', {
        data: {
          dateVal: me.model.posted_date,
          param: param,
        },
      });
    }
  }

  /**
   * Map refType với Module
   * @param {*} refType
   * @param {*} me
   * @returns
   */
  function getModuleByRefType(refType, me) {
    switch (refType) {
      case me.$ms.constant.RefType.CAReceipt:
      case me.$ms.constant.RefType.CAReceiptPlanWithdraw:
      case me.$ms.constant.RefType.CAReceiptWithdraw:
      case me.$ms.constant.RefType.CAReceiptCustomer:
      case me.$ms.constant.RefType.CAReceiptSale:
        return 'cAReceipt';
      case me.$ms.constant.RefType.BADeposit:
        return 'bADeposit';
      case me.$ms.constant.RefType.BATransferDeposit:
      case me.$ms.constant.RefType.BATransferWithdraw:
        return 'bATransfer';
      case me.$ms.constant.RefType.CAPaymentDeposit:
      case me.$ms.constant.RefType.CAPaymentPurchase:
      case me.$ms.constant.RefType.CAPayment:
        return 'cAPayment';
      case me.$ms.constant.RefType.BAWithDraw:
      case me.$ms.constant.RefType.BAWithdrawPurchase:
      case me.$ms.constant.RefType.BAWithdrawVendor:
      case me.$ms.constant.RefType.BAWithDrawSalary:
      case me.$ms.constant.RefType.BAWithDrawFixedAsset:
        return 'baWithdraw';
      case me.$ms.constant.RefType.BABankTransfer:
        return 'bABankTransfer';
      case me.$ms.constant.RefType.FAVoucherIncreament:
      case me.$ms.constant.RefType.FAVoucherAdjustment:
        return 'qltsVoucher';
      case me.$ms.constant.RefType.BUPlanWithdrawCash:
      case me.$ms.constant.RefType.BUPlanWithdrawTransfer:
      case me.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer:
      case me.$ms.constant.RefType.BUPlanWithdrawDeposit:
        return 'buPlanWithDraw';
      case me.$ms.constant.RefType.BUTransfer:
      case me.$ms.constant.RefType.BUTransferDeposit:
      case me.$ms.constant.RefType.BUTransferPurchase:
      case me.$ms.constant.RefType.BUTransferFixedAsset:
      case me.$ms.constant.RefType.BUTransferSalary:
      case me.$ms.constant.RefType.BUTreasuryFundTransferSalary:
      case me.$ms.constant.RefType.BUTreasuryFundTransferInsurancePayment:
        return 'bUTransfer';
      case me.$ms.constant.RefType.BUVoucherListPlanned:
      case me.$ms.constant.RefType.BUVoucherListNotPlanned:
      case me.$ms.constant.RefType.BUVoucherListReceipExpense:
      case me.$ms.constant.RefType.BUVoucherListOther:
      case me.$ms.constant.RefType.BUVoucherListRealExpense:
        return 'bUVoucherList';
      case me.$ms.constant.RefType.GLVoucherSummaryTable:
        return 'gLVoucherList';

      case me.$ms.constant.RefType.FAAdjustment:
        return 'fAAdjustment';
      // Bổ sung module
      case me.$ms.constant.RefType.FADecrement:
        return 'fADecrement';
      case me.$ms.constant.RefType.INOutward:
        return 'approveVoucherInInwardOutward';
      case me.$ms.constant.RefType.FADevaluation:
        return 'fADevaluation';
      case me.$ms.constant.RefType.GLProfitLossTransfer:
        return 'gLProfitLossTransferVoucher';
      case me.$ms.constant.RefType.GLPostedVoucher:
        return 'gLVoucherList';
      case me.$ms.constant.RefType.BUPlanSupplement:
        return 'buPlanReceipt';
      case me.$ms.constant.RefType.GLGeneralVoucher:
        return 'gLVoucher';
      case me.$ms.constant.RefType.SAInvoice:
        return 'sAInvoice';
      case me.$ms.constant.RefType.BUPlanSupplement:
        return 'buPlanReceipt';
      case me.$ms.constant.RefType.PUInvoice:
        return 'pUInvoice';
      case me.$ms.constant.RefType.BADepositFixedAsset:
        return 'bADeposit';
      case me.$ms.constant.RefType.GLPayrollExpense:
        return 'pAGLPayrollExpense';
      case me.$ms.constant.RefType.FASaleInvoice:
        return 'sAInvoice';
      case me.$ms.constant.RefType.FAPurchaseInvoice:
        return 'pUInvoice';
      case me.$ms.constant.RefType.OPAccoutingObjectAndBudgetChapter:
        return 'openingAccountEntry';
      case me.$ms.constant.RefType.SAReturn:
        return 'sAReturn';
      case me.$ms.constant.RefType.BUCommitmentAdjustment:
        return 'bUCommitmentAdjustment';
      case me.$ms.constant.RefType.BUPlanReceipt:
        return 'buPlanReceipt';
      case me.$ms.constant.RefType.FADepreciation:
        return 'fADepreciation';
      case me.$ms.constant.RefType.BUCommitmentRequest:
        return 'bUCommitmentRequest';
    }
    return '';
  }

  function getDetaiKeyByRefType(refType, me) {
    // Bổ sung detailKey
    switch (refType) {
      case me.$ms.constant.RefType.BUPlanWithdrawDeposit:
      case me.$ms.constant.RefType.BUPlanWithdrawCash:
      case me.$ms.constant.RefType.BUPlanWithdrawTransfer:
      case me.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer:
        return 'BuPlanWithDrawDetails';
      case me.$ms.constant.RefType.BAWithDraw:
      case me.$ms.constant.RefType.BAWithdrawVendor:
      case me.$ms.constant.RefType.BAWithDrawSalary:
      case me.$ms.constant.RefType.BUTransferFixedAsset:
      case me.$ms.constant.RefType.BUTransferPurchase:
      case me.$ms.constant.RefType.BUTransferVendorPayment:
      case me.$ms.constant.RefType.BUTransferDeposit:
      case me.$ms.constant.RefType.BUTreasuryFundTransferInsurancePayment:
      case me.$ms.constant.RefType.BUTreasuryFundTransferSalary:
      case me.$ms.constant.RefType.BUTransfer:
      case me.$ms.constant.RefType.BUTransferSalary:
        return 'Detail';
      case me.$ms.constant.RefType.BAWithDrawFixedAsset:
        return 'DetailFixedAsset';
      case me.$ms.constant.RefType.BAWithdrawPurchase:
        return 'DetailPurchase';
      case me.$ms.constant.RefType.BABankTransfer:
        return 'BABankTransferDetail';
      case me.$ms.constant.RefType.GLVoucherSummaryTable:
        return 'GLVoucherListDetails';
      case me.$ms.constant.RefType.BUVoucherListReceipExpense:
      case me.$ms.constant.RefType.BUVoucherListRealExpense:
      case me.$ms.constant.RefType.BUVoucherListPlanned:
      case me.$ms.constant.RefType.BUVoucherListNotPlanned:
        return 'BUVoucherListDetail';
      case me.$ms.constant.RefType.BUVoucherListOther:
        return 'BUVoucherListOtherDetail';
      case me.$ms.constant.RefType.CAReceipt:
      case me.$ms.constant.RefType.CAReceiptPlanWithdraw:
      case me.$ms.constant.RefType.CAReceiptWithdraw:
        return 'CAReceiptDetail';
      case me.$ms.constant.RefType.FAVoucherIncreament:
        return 'QltsVoucherDetail';
      case me.$ms.constant.RefType.PASalary:
        return 'PASalaryDetail';
      default:
        return '';
    }
  }

  return {
    selectedProject,
    selectedBank,
    selectedBankBUPlan,
    selectedAccountingObject,
    selectedAccountingObjectBank,
    onBlurActionDatePicker,
    selectedAccountingObjectBank,
    viewAccount,
    viewQuantity,
    getModuleByRefType,
    getDetaiKeyByRefType,
    getDataAccounting,
  };
};
